import React from 'react'

interface Props {
  percentage: number
  size?: number
  strokeWidth?: number
  backgroundRingColor?: string
}

export const ProgressLoader: React.FC<Props> = ({
  percentage,
  size = 28,
  strokeWidth = 6,
  backgroundRingColor = 'white',
}) => {
  const radius = 11.5 - strokeWidth / 2
  const circumference = 2 * Math.PI * radius
  const strokeDasharray = circumference
  const strokeDashoffset = circumference - (percentage / 100) * circumference

  return (
    <svg viewBox="0 0 23 23" width={size} height={size}>
      {/* Background ring */}
      <circle
        cx="11.5"
        cy="11.5"
        r={radius}
        fill="none"
        stroke={backgroundRingColor}
        strokeWidth={strokeWidth}
        strokeOpacity={0.7}
      />

      {/* Progress ring */}
      <circle
        cx="11.5"
        cy="11.5"
        r={radius}
        fill="none"
        stroke="rgba(4, 175, 0, 1)"
        strokeWidth={strokeWidth}
        strokeDasharray={strokeDasharray}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap="butt"
        transform="rotate(-90 11.5 11.5)"
      />
    </svg>
  )
}
